import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { doFetch } from "../../redux/api/actions";
import { GET_LOCATIONS, GET_MY_TOURGUIDE_PROFILE, GET_TOURS } from "../../redux/api/constants";
import ProfileView from "./profile";
import Layout from "../layout";
import { useTranslation } from "react-i18next";

const TourGuideHome = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const accessToken = useSelector(state => state.Auth.accessToken);
    const loading = useSelector(state => state.API.loading);
    const tourGuideProfile = useSelector(state => state.API.tourguide);
    const tours = useSelector(state => state.API.tours);
    const locations = useSelector(state => state.API.locations);

    const [activeTab, setActiveTab] = React.useState('tab1')

    const handleTabClick = (tab) => {
        setActiveTab(tab)
    }

    useEffect(() => {
        dispatch(doFetch(GET_MY_TOURGUIDE_PROFILE, "tourguide/me", accessToken))
        dispatch(doFetch(GET_TOURS, "tourguide/tours", accessToken))
        dispatch(doFetch(GET_LOCATIONS, "locations"))
    }, [dispatch, accessToken]);

    useEffect(() => {
        const hash = window.location.hash;
        if (hash) {
            const tab = hash.slice(1);
            setActiveTab(tab);
        }
    }, []);

    return (
        <Layout selected="tourguide">
            <div className="tourguide-dashboard">
                <nav aria-label="breadcrumb" className="breadcrumb-nav">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
	                            <Link to="/">{t('home')}</Link>
                        </li>
                        <li className="breadcrumb-item active">{t('tourguide-dashboard')}</li>
                    </ol>
                </nav>

                {!loading && (
                    tourGuideProfile ? (
                        <ProfileView 
                            tourGuideProfile={tourGuideProfile}
                            activeTab={activeTab}
                            tours={tours}
                            locations={locations}
                            handleTabClick={handleTabClick} 
                        />
                    ) : (
                        <div className="get-started-section text-center py-5">
                            <div className="mb-4">
                                <i className="bi bi-compass" style={{ fontSize: '4rem', color: '#e17055' }}></i>
                            </div>
                            <h1 className="mb-3">{t('tourguide-get-started')}</h1>
                            <p className="text-muted lead mb-4" style={{ maxWidth: '500px', margin: '0 auto' }}>
                                {t('tourguide-get-started-paragraph')}
                            </p>
                            <Link to="/tourguide/edit" className="btn-primary">
                                {t('tourguide-create-guide-profile')}
                                <i className="bi bi-arrow-right ms-2"></i>
                            </Link>
                        </div>
                    )
                )}
            </div>
        </Layout>
    );
}

export default TourGuideHome;
